import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51eacf58")

_pushScopeId("data-v-51eacf58")
const _hoisted_1 = {
  key: 0,
  class: "inquiry-contanier"
}
const _hoisted_2 = {
  key: 0,
  class: "inquiry-contanier"
}
const _hoisted_3 = { class: "inquiry-content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"inquiry-title-mg\" data-v-51eacf58><image class=\"inquiry-title\" src=\"https://websitedn.yiautos.com/channel_quotation/v4/slogan.png\" data-v-51eacf58></image></div><div class=\"inquiry-slogan\" data-v-51eacf58><div class=\"slogan1 bold\" data-v-51eacf58>原厂新车，全国比价</div><div class=\"slogan bold\" data-v-51eacf58>原厂售后，全国联保</div></div>", 2)
const _hoisted_6 = { class: "hot-info" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "hot-title" }, [
  /*#__PURE__*/_createVNode("div", { class: "hot-inquiry" }, "热门询价车型")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "swipe-img",
  src: "https://websitedn.yiautos.com/channel_quotation/v4/models-1.png"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "swipe-img",
  src: "https://websitedn.yiautos.com/channel_quotation/v4/models-2.png"
}, null, -1)
const _hoisted_10 = { class: "custom-indicator-content" }
const _hoisted_11 = {
  key: 0,
  class: "inquiry-list"
}
const _hoisted_12 = { class: "broadcast-item" }
const _hoisted_13 = {
  key: 1,
  class: "default-avator",
  src: "https://websitedn.yiautos.com/channel_quotation/v4/default-avator.png"
}
const _hoisted_14 = {
  key: 2,
  style: {"display":"flex"}
}
const _hoisted_15 = { class: "nick-name" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, "获得了", -1)
const _hoisted_17 = {
  key: 3,
  style: {"display":"flex"}
}
const _hoisted_18 = { class: "nick-name" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", null, "获得了", -1)
const _hoisted_20 = { class: "models-name" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", null, "的最新价格", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "inquiry-total-number" }, [
  /*#__PURE__*/_createTextVNode(" 目前已有 "),
  /*#__PURE__*/_createVNode("span", { class: "inquiry-number bold" }, "50000+"),
  /*#__PURE__*/_createTextVNode(" 名客户获得报价 ")
], -1)
const _hoisted_23 = { class: "service-content" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    class: "hand",
    src: "https://websitedn.yiautos.com/channel_quotation/v4/hand.png"
  })
], -1)
const _hoisted_25 = {
  key: 1,
  class: "disbale-inquiry-contanier"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  class: "empty_img",
  src: "https://wechatdn.yiautos.com/channel_query/v2/link-fail.png"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "warm-text" }, "当前页面已失效", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_notice_bar = _resolveComponent("van-notice-bar")!

  return (_ctx.isReady)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_ctx.enable)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_van_swipe, {
                    class: "my-swipe",
                    autoplay: "5000",
                    "indicator-color": "#FFDA7F",
                    onChange: _ctx.onChange
                  }, {
                    indicator: _withId(() => [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("div", {
                          class: _ctx.activeIndex === 0 ? 'active' : 'custom-indicator'
                        }, null, 2),
                        _createVNode("div", {
                          class: _ctx.activeIndex === 1 ? 'active' : 'custom-indicator'
                        }, null, 2)
                      ])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_van_swipe_item, null, {
                        default: _withId(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_swipe_item, null, {
                        default: _withId(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onChange"])
                ]),
                (_ctx.listData.length !== 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode(_component_van_notice_bar, {
                        "left-icon": "https://websitedn.yiautos.com/channel_quotation/v4/broadcast.png",
                        scrollable: false
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_van_swipe, {
                            vertical: "",
                            class: "notice-swipe",
                            autoplay: 5000,
                            "show-indicators": false,
                            touchable: false
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listData, (item) => {
                                return (_openBlock(), _createBlock(_component_van_swipe_item, { key: item }, {
                                  default: _withId(() => [
                                    _createVNode("div", _hoisted_12, [
                                      (item.avator)
                                        ? (_openBlock(), _createBlock("img", {
                                            key: 0,
                                            class: "default-avator",
                                            src: item.avator
                                          }, null, 8, ["src"]))
                                        : (_openBlock(), _createBlock("img", _hoisted_13)),
                                      (item.nickName)
                                        ? (_openBlock(), _createBlock("div", _hoisted_14, [
                                            _createVNode("div", _hoisted_15, _toDisplayString(item.nickName), 1),
                                            _hoisted_16
                                          ]))
                                        : (_openBlock(), _createBlock("div", _hoisted_17, [
                                            _createVNode("div", _hoisted_18, "用户" + _toDisplayString(item.mobile), 1),
                                            _hoisted_19
                                          ])),
                                      _createVNode("div", _hoisted_20, _toDisplayString(item.seriesName), 1),
                                      _hoisted_21
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_22,
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", {
                    class: "inquiry-btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.inquiryContent && _ctx.inquiryContent(...args)))
                  }),
                  _hoisted_24
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_25, [
              _hoisted_26,
              _hoisted_27
            ]))
      ]))
    : _createCommentVNode("", true)
})